module.exports = __webpack_public_path__ + "img/hotdog.25ee1a77.svg";